import * as React from 'react';
import { useSelector } from 'react-redux';
import { ProfessionalSearchPromo } from '../../components/ProfessionalSearchPromo';
import { selectProfessionalSearchUrl } from '../../selectors/selectProfessionalSearchUrl';
import { trackProfessionalSearchClick } from '../../serp/containers/SummaryContainer/containers/tracking';

export const ProfessionalSearchPromoContainer = () => {
  const link = useSelector(selectProfessionalSearchUrl);

  return <ProfessionalSearchPromo link={link} onClick={trackProfessionalSearchClick} />;
};
